import { isNil } from "lodash";
import { InsightChildSearchPeers, ProjectCompanySet } from "services/projects/project.types";
import { ChipEntity } from "types";
import { columnsCompanyNameDomainOS, DomainPeer } from "services";
import { requestCompaniesData } from "components/Talent/Companies/Companies.functions";

export const locationList = [
    {
        key: 0,
        value: "National",
        selected: false,
    },
    {
        key: 1,
        value: "International",
        selected: true,
    },
];

export const getSelectedElements = ({ selected }: { selected: boolean }) => selected === true;
export const getElementKey = ({ key }: { key: number }) => key;

export const mapForChipEntity = ({
    id,
    name,
    selected,
    erasable,
}: {
    id: number;
    name: string;
    selected?: boolean;
    erasable?: boolean;
}) => ({
    key: id,
    value: name,
    selected: erasable === undefined ? true : Boolean(selected),
    erasable: erasable === undefined ? false : Boolean(erasable),
});

export const mapForChipEntityPeers = (peer: any) => {
    const location = peer.locations?.[0]?.location;
    return {
        ...peer,
        key: peer.id,
        value: peer.name,
        selected: true,
        erasable: true,
        ...(location
            ? {
                  location: {
                      country: location.country?.name ?? "",
                      country_id: location.country?.id ?? 0,
                      city: location.city ?? "",
                      city_id: location.id ?? 0,
                  },
              }
            : {}),
    };
};

export const getUpdatedLocationList = (locations: ChipEntity[], value: number | null | undefined) => {
    const newLocationList = locations.map((location) => {
        if (!isNil(value) && value > 0 && location.key === 0) {
            return { ...location, selected: true };
        }
        if (!isNil(value) && value === 0 && location.key === 1) {
            return { ...location, selected: true };
        }
        if (!value && location.key === 1) {
            return { ...location, selected: true };
        }
        return { ...location, selected: false };
    });
    return newLocationList;
};

export const getFiltersElements = (
    filters: InsightChildSearchPeers | undefined,
    elementType: "products" | "sectors"
) => {
    if (!filters?.data?.[elementType]?.length) {
        return;
    }

    if (!filters.hasOwnProperty("meta_ui")) {
        return filters.data[elementType].map(mapForChipEntity);
    }

    const newElements = filters.data[elementType].map((element, i) => {
        const elementMetaUI = filters.meta_ui?.[elementType]?.[i];
        const newElement = { ...element, ...elementMetaUI };
        return mapForChipEntity(newElement);
    });

    return newElements;
};

export const getInitialPeersData = async (companySet: ProjectCompanySet) => {
    const params = [...columnsCompanyNameDomainOS, "description"];
    const companyIds = companySet.data.company_ids;
    let peers = [] as ChipEntity[];

    if (companyIds.length) {
        const peersResults = await requestCompaniesData<DomainPeer>(companySet.data.company_ids, params);
        peers = peersResults.map((company) => mapForChipEntityPeers(company));
    }

    return peers;
};
